(function ($) {
    $(document).ready(function () {
        var maxWidth = 0;
        if ($("div .resource-list-description").length) {
            $("div .resource-list-description").each(function (){
				if( $(this).width() > maxWidth ){
					maxWidth = $(this).find("p").width();
				}
			});
            $("div .resource-list-description").width(maxWidth);
        }

    });
}(window.jQuery));


//A14 with new tab variant begins here
var arrayLink = $("a.renderpdf");
if (arrayLink.length > 0) {
    arrayLink.each(function (index) {
        var href = $(arrayLink[index]).attr('href');
        if (href.length > 0) {
            if (href.indexOf("?") == -1) {
                href = href + "?renderpdf=1";
            }
            else {
                href = href + "&renderpdf=1";
            }
            $(arrayLink[index]).attr('href', href).attr('target', '_blank');
        }
    });
}

(function ($) {
    $('.a14-form-link').each(function () {
        var targetid = $(this).attr('data-bs-target');
        var targethref = $(this).attr('data-href');

        var a14session = sessionStorage.getItem('a14formId');
        if (a14session != null) {
            a14session = JSON.parse(a14session);
            for (var i = 0; i < a14session.length; i++) {
                if (a14session[i] == targetid) {
                    $(this).attr('href', targethref);
                    $(this).attr('data-bs-toggle', '');
                }
            }
        }
        $(targetid).children().find(".sitecore-form").addClass("a14-form-modal");
        $(targetid).attr('data-href', targethref);
        $(targetid).find('form').attr('data-a14-form', 'true');
        $(targetid).find('form').attr('data-a14-link-id', targetid);
    });
}(window.jQuery));



//Analytics

analytics.eventConfig.push(
    {
        "target": ".component.a14-resource-list",
        "codeId": "a14",
        "events": [
            {
                "eventTarget": ".resource-list-description a:not([data-bs-toggle*=modal])",
                "eventType": "click",
                "analytics": "true",
                "tags": {
                    "componentId": "a14",
                    "componentName": "resource list",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('.pdf') !== -1",
                            "value": "resource list download link"
                        },
                        {
                            "rule": "true",
                            "value": "resource list link"
                        }
                    ],
                    "event": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('.pdf') !== -1",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('.pdf') !== -1",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "resource list internal navigation click"
                        }
                    ],
                    "listOrdinal": {
                        "ref": ".component",
                        "ele": ".div-table-row"
                    },
                    "listSource": "",
                    "parentName": "",
                    "parentTitle": "",
                    "titleText": "",
                    "fileName": ""
                }
            },
            {
                "eventTarget": ".resource-list-action a:not([data-bs-toggle*=modal])",
                "eventType": "click",
                "analytics": "true",
                "tags": {
                    "componentId": "a14",
                    "componentName": "resource list",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "resource list download link",
                    "event": "download",
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('sds') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "true",
                            "value": "other media asset click"
                        }
                    ],
                    "fileName": "",
                    "listOrdinal": {
                        "ref": ".component",
                        "ele": ".div-table-row"
                    },
                    "listSource": "",
                    "parentName": "",
                    "parentTitle": "",
                    "titleText": ""
                }
            }
        ]
    },
)
